export var ActivityType;
(function (ActivityType) {
    ActivityType["ALERT"] = "Alert";
})(ActivityType || (ActivityType = {}));
export class CreateActivityBody {
    constructor(incidentId, incidentSequence, type, activityData) { }
}
